export const pacRegex = new RegExp('^[a-zA-Z]{3}[0-9]{6}$')
export const stacRegex = new RegExp('^[0-9]{6}[a-zA-Z]{3}$')
